import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { TracksServiceWeb } from '@asset-old/shared/services/analytics/tracks.service';

@Component({
  selector: 'app-button',
  standalone: false,
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
})
export class ButtonComponent implements OnInit, OnChanges {
  @Input('btnId') id: string;
  @Input('text') text: string;
  @Input('css') css: string = '';
  @Input('color') color: string;
  @Input('disabled') disabled: boolean;
  @Input('gaAction') gaAction: string;
  @Input('gaPath') gaPath: string;
  @Input('gaLabel') gaLabel: string;
  @Input('tab') tabindex: number = 0;
  @Output('onClick') onClick: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('button') button: ElementRef;

  constructor(private analytics: TracksServiceWeb) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled != undefined)
      this.disabled = changes.disabled.currentValue;
  }

  ngOnInit(): void {
    this.color = this.color || 'default';
  }

  click(event) {
    if (this.gaPath && this.gaLabel && this.gaAction) {
      this.analytics.tracks.newEvent(
        'click',
        this.gaPath,
        `botao:${this.gaLabel}`,
        true
      );
    }
    this.onClick.emit(event);
  }
}
